<template>
  <div class="col-md-12 project-list">
    <div class="card">
      <div class="row">
        <div class="col-md-6 d-flex">
          <ul
            class="nav nav-tabs border-tab"
            id="top-tab"
            role="tablist"
            v-for="(item, index) in tab"
            :key="index"
          >
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{ active: item.active }"
                id="top-home-tab"
                data-bs-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="top-home"
                :aria-selected="item.active ? 'true' : 'false'"
                @click.prevent="active(item)"
                >{{ item.name }}</a
              >
            </li>
          </ul>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-0 me-0"></div>
          <button
            class="btn btn-primary"
            type="button"
            @click="createModal.show()"
          >
            Crear Evento
          </button>

          <div
            class="modal fade"
            ref="eventModal"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title fs-5 text-uppercase">
                    Formulario de registro de eventos
                  </h5>
                  <button
                    type="button"
                    class="btn-close"
                    @click="closeModal"
                  ></button>
                </div>
                <div class="modal-body">
                  <EventForm @reloadEvents="refreshList" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-12">
    <div class="card">
      <div class="card-body">
        <div class="tab-content" id="top-tabContent">
          <div
            class="tab-pane fade"
            :class="{ 'active show': item.active }"
            :id="item.id"
            role="tabpanel"
            :aria-labelledby="item.label"
            v-for="(item, index) in tab"
            :key="index"
          >
            <component
              :is="item.type"
              :list="listEvents"
              @reloadList="loadItems"
            ></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import axios from "@/includes/connection";
import { ref, onMounted, markRaw } from "vue";
import doingPage from "../projectlist/doingPage.vue";
import donePage from "../projectlist/donePage.vue";
import activePage from "../projectlist/activePage.vue";
import { Modal } from "bootstrap";
import BaseForm from "@/pages/eventos/components/baseForm.vue";
import EventForm from "@/pages/eventos/components/eventForm.vue";

const eventModal = ref(null);
const loading = ref(false);
let createModal = null;
const listEvents = ref([]);
const currentTab = ref("Creados");

let tab = ref([
  {
    type: markRaw(doingPage),
    name: "Creados",
    active: true,
    id: "tab-creados",
    label: "tab-creados-label",
  },
  {
    type: markRaw(activePage),
    name: "Activos",
    active: false,
    id: "tab-activos",
    label: "tab-activos-label",
  },
  {
    type: markRaw(donePage),
    name: "Concluidos",
    active: false,
    id: "tab-concluidos",
    label: "tab-concluidos-label",
  },
]);

function active(item) {
  tab.value.forEach((a) => (a.active = false));
  item.active = true;
  currentTab.value = item.name;
  loadItems();
}

onMounted(() => {
  createModal = new Modal(eventModal.value);
  loadItems();
});

function refreshList() {
  createModal.hide();
  loadItems();
}
function closeModal() {
  createModal.hide();
}

async function loadItems() {
  loading.value = true;
  try {
    let response;
    switch (currentTab.value) {
      case "Creados":
        response = await axios.get("/event/created");
        break;
      case "Activos":
        response = await axios.get("/event/active");
        break;
      case "Concluidos":
        response = await axios.get("/event/done");
        break;
      default:
        response = { data: [] };
    }
    listEvents.value = response.data;
  } catch (error) {
    console.error("Error cargando eventos:", error);
    listEvents.value = [];
  } finally {
    loading.value = false;
  }
}
</script>
